import { render } from "./Beta.vue?vue&type=template&id=bf49b5e6&scoped=true"
import script from "./Beta.vue?vue&type=script&lang=js"
export * from "./Beta.vue?vue&type=script&lang=js"

import "./Beta.vue?vue&type=style&index=0&id=bf49b5e6&scoped=true&lang=stylus"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf49b5e6"]])

export default __exports__